// extracted by mini-css-extract-plugin
export default {"divBarraInfo":"stylesBarraInformacoes_divBarraInfo__lOzwz"};